const operationPackageConfigEn = {
  actions: {
    addPattern: 'Add pattern',
    archive: 'Archive',
    archiveError: 'Failed to archive the pattern',
    archiveSuccess: 'Pattern archived',
    duplicate: 'Duplicate',
    duplicateAndRecreate: 'Duplicate and recreate',
    duplicateError: 'Failed to duplicate the pattern',
    duplicateSuccess: 'Pattern duplicated',
    menuLabel: 'Actions'
  },
  archivedReadOnlyNotice: {
    description: 'Archived patterns are view-only. To reuse the content, duplicate this pattern.',
    title: 'This pattern is archived and cannot be edited.'
  },
  assignment: {
    addPerson: 'Add person',
    back: 'Back',
    cancel: 'Cancel',
    designationModeDescription: 'Configure how approver designation is handled at submit time.',
    designationModeHelp: {
      none: 'No approver designation is required at submit time.',
      optional: 'You can optionally designate approvers before submitting.',
      required: 'Approver designation is required before submission.'
    },
    designationModeLabel: 'Designation mode',
    designationModeOption: {
      none: 'No designation',
      optional: 'Optional designation',
      required: 'Required designation'
    },
    designationModePlaceholder: 'Select designation mode',
    eligibleAssignee: 'Eligible assignee',
    loading: 'Loading...',
    option: {
      operator: 'Operator',
      peopleGroup: 'People group',
      person: 'Person',
      target: 'Target'
    },
    parallelTasks: 'Parallel Tasks',
    select: 'Select',
    selectPeopleGroupPrompt: 'Please select a people group.',
    selectPersonPrompt: 'Select a person from the dropdown.',
    success: 'Assignee settings updated',
    unconfigured: 'Not configured'
  },
  attribute: {
    status: {
      readonly: 'readonly'
    },
    usage: {
      allNotUsedDisabled: 'At least one item must be used',
      definition: 'definition',
      itemName: 'name',
      notUsed: 'Not needed',
      readOnly: 'This item is read-only and cannot be edited',
      systemRequired: 'System required',
      usage: 'usage'
    }
  },
  createPatternDialog: {
    description: 'Enter pattern name and description',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter the purpose or features of the pattern',
    nameLabel: 'Pattern Name',
    namePlaceholder: 'e.g., New Hire Pattern',
    title: 'Create New Pattern'
  },
  detailActions: {
    backToList: 'Back to list',
    duplicateAndEdit: 'Duplicate and edit',
    saveChanges: 'Save changes',
    saveSuccess: 'Changes saved'
  },
  duplicatePatternDialog: {
    callout: 'The settings of "{{name}}" will be carried over. Employee responses will not be carried over; the pattern will start as a draft.',
    confirmButton: 'Duplicate',
    defaultName: 'Copy of {{name}}',
    description: 'Create a new pattern by carrying over the questions from the source pattern.',
    nameLabel: 'Pattern Name',
    title: 'Create new pattern'
  },
  editDisabledWarning: {
    description: 'Changing the questions (items, options, required settings) would conflict with already-submitted requests, so editing is disabled after publishing. Viewing only. To change the content, duplicate this pattern.',
    title: 'Editing is disabled because there are requests or responses from employees.'
  },
  error: {
    cannotDisableApprovalTask: 'Approval tasks cannot be disabled',
    cannotDisableSystemRequiredTask: 'Tasks containing system required items cannot be disabled',
    disableFailed: 'Disable failed',
    enableFailed: 'Enable failed'
  },
  notUsed: {
    tasks: 'Unused tasks',
    title: 'Not used'
  },
  packagePatternDetail: {
    configure: 'Configure',
    configuring: 'Configuring'
  },
  patternDraftBadge: 'Draft',
  success: {
    enableTaskDescription: "Task '{{name}}' has been enabled",
    taskDisabled: "Task '{{name}}' has been disabled"
  },
  tabs: {
    archived: 'Archived',
    draft: 'Draft',
    inUse: 'In use'
  }
};
export default operationPackageConfigEn;